module.exports = __webpack_public_path__ + "img/media.110ed5c0.png";